'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  appearance: none;\n  font-size: 16px;\n  font-family: Source Sans Pro, sans-serif;\n  width: ", ";\n  ", ";\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  border-radius: 0;\n  background: white;\n  ", ";\n  ", ";\n\n  ", ";\n\n  &:focus {\n    border: 1px solid ", ";\n    outline: none;\n  }\n\n  ", ";\n"], ["\n  appearance: none;\n  font-size: 16px;\n  font-family: Source Sans Pro, sans-serif;\n  width: ", ";\n  ", ";\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  border-radius: 0;\n  background: white;\n  ", ";\n  ", ";\n\n  ", ";\n\n  &:focus {\n    border: 1px solid ", ";\n    outline: none;\n  }\n\n  ", ";\n"]);

var commonInputStyle = styled.css(_templateObject, function (props) {
  return props.width ? "" + props.width : "100%";
}, function (props) {
  return props.maxWidth && "max-width: " + props.maxWidth + "px";
}, settings.COLOR.lineGray, function (props) {
  return props.error && "border-color: " + settings.COLOR.softRed;
}, function (props) {
  return props.error && "background: " + settings.COLOR.lightSoftRed;
}, function (props) {
  return props.disabled && "\n    background: " + settings.COLOR.whiteTwo + ";\n    color: " + settings.COLOR.lightGray + ";\n    cursor: not-allowed;\n  ";
}, settings.COLOR.brightBlue, function (props) {
  return props.style;
});

exports.commonInputStyle = commonInputStyle;
//# sourceMappingURL=style-cf128dc7.js.map
